import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateSessionPayload } from '@app-store/slices/sessions/createSession'

interface TaskAction extends Action {
    payload: ICreateSessionPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sessions.create

function* createSessionSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/event/session`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        // console.log(error)
        yield put(onFailure(error))
    }
}

function* createSessionSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createSessionSagaTask)
}

export default createSessionSaga
